import { Clinic } from "pwapi";

export const getClinicPhone = (clinic: Clinic): string | false => {
  if (clinic?.phone) {
    return clinic.phone;
  }
  if (clinic?.location?.phone1) {
    return clinic.location.phone1;
  }
  if (clinic?.location?.phone2) {
    return clinic.location.phone2;
  }
  return false;
};
